const routerM = [
  {
    path: '/',
    name: 'm',
    component: (resolve) => require(['@/pages/mobile/index'], resolve)
  }
]

export default routerM



// WEBPACK FOOTER //
// ./src/router/routerM.js